






































import { Component, Vue, Prop } from 'vue-property-decorator';
import ContestListItemLike from "../models/ContestListItem";

@Component({
    components: {
    },
})
export default class ContestListItem extends Vue {
    @Prop() item!: ContestListItemLike;
    @Prop() isHistory!: boolean;

    private joinContest() {
        this.$emit('joinContest', this.item.id)
    }

    private viewContest() {
        if (this.isHistory) {
            this.$router.push(`/contests/${this.item.id}/detail`)
            return
        }
        this.$router.push(`/contests/${this.item.id}/lineup`)
    }

    private get full() {
        return ((this.item.spots / this.item.totalSpots) * 100).toFixed(0)
    }

}
